import request from '../utils/request'
const serviceName = 'prjPart'

export function getRoots() {
  return request({
    url:`/${serviceName}/getRoots`,
    method:'get'
  })
}

export function getChildren(code) {
  return request({
    url:`/${serviceName}/getChildren/${code}`,
    method:'get'
  })
}

export function getPathByCode(code) {
  return request({
    url:`/prjPart/getPathByCode?partCode=${code}`,
    method:'get'
  })
}

//质检资料-工程划分树(根据划分树名称模糊插叙)
export function getPrjPartApiByName (id, data,name) {
  return request({
    url: `fusion/qualityDatum/partDocTree/${id}`+'?name='+encodeURIComponent(name),
    method: 'post',
    data
  })
}

//质量安全资料-工程划分树
export function getPrjPartApiById (id, data) {
  return request({
    url: `fusion/qualityDatum/partDoc/${id}`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/prjPart.js